import TripInformationView from './TripInformationView';
import './TripInformationView.scss';

export default TripInformationView;
